import React from 'react'
import styled from 'styled-components'
import { useActiveWeb3React } from '../../hooks'
import { useWalletModalToggle } from '../../state/application/hooks'

import Vesting from './Vesting'
import { ButtonLight } from '../../components/Button'
import axios from 'axios'
import LoaderCustom from '../../components/LoaderCustom'

const ContainerStyled = styled.div`
  width: 100%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 200px;
  @media (min-width: 502px) {
    padding: 10px;
  }
`

const TitleStyled = styled.div`
  display: flex;
  width: 100%;
  color: white;
  font-size: 18px;
  font-weight: 600;
  gap: 8px;
  text-decoration: none;
  align-items: center;
  padding: 20px 10px;
  background: rgb(23, 23, 23);
  border-radius: 12px;
  transition: all 300ms;

  svg {
    height: 30px;
    width: 30px;
  }
`

const ConnectWalletContainer = styled.div`
  background: rgb(23, 23, 23);
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  padding: 30px;
  width: 100%;
  margin: auto;
`

const VC_SOURCE_URL = 'https://raw.githubusercontent.com/HyperSwapX/raise_list/refs/heads/main/list.json'

const VC = () => {
  const { account } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const [list, setList] = React.useState<any>({})
  const [loading, setLoading] = React.useState<boolean>(true)

  React.useEffect(() => {
    const fetchVCList = async () => {
      try {
        setLoading(true)
        const response = await axios.get(VC_SOURCE_URL)
        const vcListRaw = response.data
        if (vcListRaw) {
          setList(vcListRaw)
        } else {
          setList([])
        }

        setLoading(false)
      } catch (error) {
        console.error('Error fetching VC list:', error)
        setLoading(false)
      }
    }

    if (loading) {
      fetchVCList()
    }
  }, [account, loading])

  if (loading) {
    return <LoaderCustom />
  }

  const accountContracts = account ? list[account] : undefined

  return (
    <ContainerStyled>
      <TitleStyled>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M5 4h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1" />
          <path d="M5 16h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1" />
          <path d="M15 12h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1" />
          <path d="M15 4h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1" />
        </svg>
        Dashboard
      </TitleStyled>
      {account ? (
        <>
          {accountContracts ? (
            <>
              {accountContracts.contracts.map((address: string) => {
                return <Vesting key={address} contractAddress={address} />
              })}
            </>
          ) : (
            <ConnectWalletContainer>
              <p style={{ textAlign: 'center', color: 'lightgrey', marginTop: '50px' }}>
                No token vesting contract is associated with your wallet. <br /> <br />
                Please switch to a different wallet or contact the team if you believe this is an error.
              </p>{' '}
            </ConnectWalletContainer>
          )}
        </>
      ) : (
        <ConnectWalletContainer>
          <p
            style={{
              width: '100%',
              color: 'lightgrey',
              paddingBottom: '16px',
              fontSize: '14px',
              marginTop: '0',
            }}
          >
            Connect your wallet to see your vesting tokens.
          </p>
          <ButtonLight style={{ padding: 16, gridColumn: 'span 12' }} onClick={toggleWalletModal}>
            Connect Wallet
          </ButtonLight>
        </ConnectWalletContainer>
      )}
    </ContainerStyled>
  )
}

export default VC
